// extracted by mini-css-extract-plugin
export var comingSoon = "Events-module--comingSoon--3fec2";
export var description = "Events-module--description--bd271";
export var evenRow = "Events-module--evenRow--364e4";
export var eventCondensedInfo = "Events-module--eventCondensedInfo--16266";
export var eventItem = "Events-module--eventItem--4ec06";
export var eventItemHeader = "Events-module--eventItemHeader--77c23";
export var format = "Events-module--format--80a1d";
export var holder = "Events-module--holder--6e73c";
export var language = "Events-module--language--3ddb1";
export var location = "Events-module--location--b369a";
export var name = "Events-module--name--953ed";
export var registration = "Events-module--registration--ee945";
export var sectionHeader = "Events-module--sectionHeader--338ef";
export var when = "Events-module--when--80fbd";
export var wrapper = "Events-module--wrapper--7a9ed";